import { WPSlide, WPTextSlide, SlideTypes, TextSlide } from "../../types/Slides";
import { getGlobalSlideData } from "../useProcessWordpressSlides";

export async function transformTextSlide(slide: WPSlide<WPTextSlide>, getImages: (imageId: number) => Promise<string>): Promise<TextSlide[]> {
  const acfSlide = slide.acf;
  const textSlide = acfSlide[SlideTypes.TEXT_SLIDE];
  const res: TextSlide = {
    type: SlideTypes.TEXT_SLIDE,
    title: textSlide.title,
    length: textSlide.length,
    imageLength: 0,
    categoryImage: (await getImages(textSlide.backgroundImage)) ?? "",
    category: {
      id: 0,
      subject: textSlide.showCategory
        ? {
          subject: textSlide.category.text,
          icon: textSlide.category.icon
        }
        : undefined,
      images: []
    },
    content: textSlide.text,
    postImage: [],
    titleOnlyFirstImage: false,
    categoryId: 0,
    ...getGlobalSlideData(slide)
  };
  return [res];
}
